import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../app/app.state';
import {TitleBreadcrumbsChangedAction, TitleChangedAction} from '../../../../core/actions/title.actions';
import {UrlService} from '../../../../core/services/url.service';
import {SubnavComponent, SubnavItem} from '../../../components/subnav/subnav.component';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'motn-manage-apps',
  templateUrl: './manage-apps.component.html',
  styleUrls: ['./manage-apps.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SubnavComponent,
    RouterOutlet,
  ],
})
export class ManageAppsComponent implements OnInit {
  subnavItems: SubnavItem[] = [
    {
      text: 'My Apps',
      href: UrlService.makeAppsManageExistingUrl(),
    },
    {
      text: 'Add Apps',
      href: UrlService.makeAppsManageNewUrl(),
    },
  ];


  constructor(
    private store: Store<AppState>,
  ) {
  }


  ngOnInit(): void {
    this.updateTitle();
  }


  private updateTitle() {
    this.store.dispatch(new TitleChangedAction(
      null,
      'Manage Apps',
    ));

    this.store.dispatch(new TitleBreadcrumbsChangedAction(
      [
        {
          text: 'Apps',
          path: UrlService.makeAppsHomeUrl(),
        },
        {
          text: 'Manage',
        },
      ],
    ));
  }
}
